import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useFormContext } from '../Context/FormContext';

const CountryList = () => {
  const [countries, setCountries] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const { formData, updateFormData, formStates, updateFormStates } = useFormContext();


  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get('https://restcountries.com/v3.1/all');
        const countriesData = response.data.map((country) => ({
          value: country.name.common,
          label: country.name.common,
        }));
        const sortedCountries = countriesData.sort((a, b) => {
          return a.label.localeCompare(b.label);
        });
        setCountries(sortedCountries);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchCountries();
  }, []);

  const handleSearchChange = (selectedOption) => {
    console.log(selectedOption?.value)
    if (selectedOption) {
        // If a new option is selected
        setSearchValue(selectedOption?.label);
        updateFormData({flag: selectedOption?.value})
      } else {
        // If the user is typing in the search input
        setSearchValue('');
      }
  };


  return (
    <div className='col-span-6'>
        <label className='mb-3'>Flag</label>
      <Select
        options={countries}
        onChange={handleSearchChange}
        isSearchable
        onInputChange={handleSearchChange}
        placeholder="Search for a country..."
      />
    </div>
  );
};

export default CountryList;
